import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.every.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.map.get-or-insert.js";
import "core-js/modules/es.map.get-or-insert-computed.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getItemWiseSalesLedgerReport, downloadExcelItemWiseSalesLedger, clearItemWiseSalesLedgerCache } from '@/api/reports';
import Pagination from '@/components/Pagination/index.vue';
import { getQuery } from '@/utils/index';
import Inr from '@/components/Inr/index.vue';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { getStates } from '@/api/locations/states';
import { getCities } from '@/api/locations/cities';
import { searchProducts } from '@/api/products';
import { getAdmins } from '@/api/admins';
import { BranchAgentService } from '@/services/branch-agent-service';
import { cleanListQuery, isAdmin, isSuperAdmin, isBranchManager, isZonalManager } from '@/common';
import { getRanges } from '@/api/ranges';
import { getCategories } from '@/api/categories';
import moment from 'moment';
import * as XLSX from 'xlsx';
import { BRANCH_MANAGER, ZONAL_MANAGER } from '@/constants/roles.constants';
// Row keys used to match a sheet row back to its API row. The workbook is
// built server-side while the manager names come from a separate JSON call, so
// the two responses cannot be assumed to agree on ordering, and the sheet may
// carry title, group or subtotal rows. Matching on a key instead of on position
// means an unexpected row shifts nothing: it simply finds no match. Schemes are
// tried in order; the report row id is unique, the invoice number + item pair
// is the fallback for a sheet that omits the id column. Header names are
// normalized (lowercased, non-alphanumerics stripped) before comparison.
const MANAGER_JOIN_SCHEMES = [{
  headers: ['id'],
  fields: ['id']
}, {
  headers: ['invoicenumber', 'item'],
  fields: ['invoiceNumber', 'productName']
}];
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.total = 0;
    this.list = [];
    this.listLoading = false;
    this.downloadLoading = false;
    this.dateRange = {
      start: '',
      end: ''
    };
    this.isAgent = false;
    this.agentList = [];
    this.stateList = [];
    this.cityList = [];
    this.dealerList = [];
    this.products = [];
    this.branchList = [];
    this.dealerListLoading = false;
    this.cityListLoading = false;
    this.productListLoading = false;
    this.selectedProduct = null;
    this.categoryId = null;
    this.subCategoryId = null;
    this.rangeList = [];
    this.categoryList = [];
    this.subCategoryList = [];
    this.assignedBranches = [] || null;
    this.salesExecutiveAdmins = [];
    this.zonalManagerAdmins = [];
    this.showFilters = false;
    this.hasSearched = false;
    this.paymentTypeOptions = [{
      label: 'Invoice',
      value: 'Invoice'
    }, {
      label: 'Debit Note-Item Wise',
      value: 'Debit Note-Item Wise'
    }, {
      label: 'Credit Note-Item Wise',
      value: 'Credit Note-Item Wise'
    }, {
      label: 'Purchase',
      value: 'Purchase'
    }, {
      label: 'Credit Note Inward',
      value: 'Credit Note Inward'
    }];
    this.paymentTypeLegend = [{
      type: 'Invoice'
    }, {
      type: 'Credit Note-Item Wise'
    }, {
      type: 'Debit Note-Item Wise'
    }, {
      type: 'Purchase'
    }, {
      type: 'Credit Note Inward'
    }];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
    this.listQuery = {
      page: 1,
      limit: 10,
      paymentType: undefined,
      dealerId: undefined,
      agentId: undefined,
      productId: undefined,
      categoryId: undefined,
      subCategoryId: undefined,
      productVariationId: undefined,
      cityName: undefined,
      stateId: undefined,
      startDate: undefined,
      endDate: undefined,
      branchId: undefined
    };
    this.loggedInAdmin = null;
  }
  async activated() {
    try {
      this.loggedInAdmin = AdminModule;
      if (this.loggedInAdmin.userType === 'Agent') {
        this.isAgent = true;
        this.listQuery.agentId = this.loggedInAdmin.agentId;
      }
      this.assignedBranches = await BranchAgentService.assignBranchId();
      if (this.assignedBranches === null) {
        throw new Error('You are not assigned to a branch.');
      }
      this.agentList = await BranchAgentService.fetchAgents(this.assignedBranches);
      this.branchList = await BranchAgentService.fetchBranches(this.assignedBranches);
      this.listQuery = {
        ...this.listQuery,
        ...this.$route.query
      };
      this.fetchSalesExecutiveManagers();
      this.fetchZonalAdminManagers();
      await this.getStateList();
      await this.fetchRanges();
    } catch (err) {
      if (err instanceof Error) {
        this.$notify.error({
          title: 'Error',
          message: err.message
        });
      }
      this.listLoading = false;
    }
  }
  isSalesExecutiveAdmin() {
    return isBranchManager();
  }
  isZonalManagerAdmin() {
    return isZonalManager();
  }
  async fetchSalesExecutiveManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [BRANCH_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.salesExecutiveAdmins = allManagers.data;
  }
  async fetchZonalAdminManagers() {
    const allManagers = await getAdmins(getQuery({
      enabled: true,
      adminsRoleId: [ZONAL_MANAGER],
      filter: {
        enabled: '$eq',
        adminsRoleId: '$in'
      }
    }));
    this.zonalManagerAdmins = allManagers.data;
  }
  async fetchSubCategories() {
    if (this.categoryId) {
      this.subCategoryList = await getCategories(getQuery({
        enabled: true,
        parentId: this.categoryId,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$in',
          rangeId: '$in'
        }
      }));
      if (this.subCategoryList.length === 0) {
        this.subCategoryId = undefined;
      }
    } else {
      this.subCategoryList = [];
    }
  }
  async fetchCategories() {
    if (this.listQuery.rangeId) {
      this.categoryList = await getCategories(getQuery({
        enabled: true,
        parentId: true,
        rangeId: this.listQuery.rangeId,
        sort: 'name,ASC',
        filter: {
          enabled: '$eq',
          parentId: '$isnull',
          rangeId: '$in'
        }
      }));
      if (this.categoryList.length === 0) {
        this.categoryId = undefined;
      }
    } else {
      this.categoryList = [];
    }
  }
  handleSubCategoryFilter() {
    this.subCategoryId = undefined;
    if (this.categoryId) {
      this.fetchSubCategories();
    } else {
      this.categoryId = undefined;
    }
    this.getList();
  }
  handleCategoryFilter() {
    this.categoryId = undefined;
    this.subCategoryId = undefined;
    this.fetchCategories();
    this.getList();
  }
  async fetchRanges() {
    this.rangeList = await getRanges(getQuery({
      enabled: true,
      sort: 'name,ASC',
      filter: {
        enabled: '$eq'
      }
    }));
  }
  paymentTypeRowClass(row) {
    switch (row === null || row === void 0 ? void 0 : row.paymentType) {
      case 'Invoice':
        return 'row-invoice';
      case 'Credit Note-Item Wise':
        return 'row-credit-note-item-wise';
      case 'Debit Note-Item Wise':
        return 'row-debit-note-item-wise';
      case 'Purchase':
        return 'row-purchase';
      case 'Credit Note Inward':
        return 'row-credit-note-inward';
      default:
        return '';
    }
  }
  getRowClassName({
    row
  }) {
    return this.paymentTypeRowClass(row);
  }
  paymentTypeTagType(paymentType) {
    switch (paymentType) {
      case 'Invoice':
        return 'success';
      case 'Credit Note-Item Wise':
        return 'danger';
      case 'Debit Note-Item Wise':
        return 'warning';
      case 'Purchase':
        return 'primary';
      case 'Credit Note Inward':
        return 'info';
      default:
        return 'info';
    }
  }
  async getList() {
    try {
      this.listLoading = true;
      this.listQuery = cleanListQuery(this.listQuery);
      if (this.dateRange) {
        this.listQuery.startDate = this.dateRange.start;
        this.listQuery.endDate = this.dateRange.end;
      }
      this.listQuery.categoryId = undefined;
      if (this.categoryId) {
        this.listQuery.categoryId = this.categoryId;
      }
      if (this.subCategoryId) {
        this.listQuery.subCategoryId = this.subCategoryId;
      }
      const data = await getItemWiseSalesLedgerReport(getQuery(this.listQuery));
      this.list = data.data;
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        searchBy: isNumeric ? 'dealerId' : 'name',
        applyBranchIdFilter: true,
        branchId: null,
        agentId: null
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getStateList() {
    try {
      this.stateList = await getStates(getQuery({
        enabled: true,
        sort: 'name,ASC',
        filter: {
          enabled: 'eq'
        }
      }));
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getCityList(stateId = null) {
    try {
      if (stateId.length > 0) {
        this.cityListLoading = true;
        this.cityList = await getCities(getQuery({
          enabled: true,
          stateId,
          sort: 'name,ASC',
          filter: {
            enabled: '$eq',
            stateId: '$in'
          }
        }));
        this.cityListLoading = false;
      }
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async getProductList(query) {
    try {
      this.productListLoading = true;
      if (query && query.length > 2) {
        this.products = await searchProducts(getQuery({
          keyword: query,
          searchByCatalogueCode: false
        }));
      }
      this.productListLoading = false;
    } catch (err) {
      this.productListLoading = false;
      throw err;
    }
  }
  handleProductSelection(value) {
    if (value) {
      if (Array.isArray(value)) {
        const productIds = [];
        const productVariationIds = [];
        value.forEach(item => {
          if (item.startsWith('product-')) {
            productIds.push(+item.replace('product-', ''));
          } else if (item.startsWith('variation-')) {
            productVariationIds.push(+item.replace('variation-', ''));
          }
        });
        this.listQuery.productId = productIds.length ? productIds : undefined;
        this.listQuery.productVariationId = productVariationIds.length ? productVariationIds : undefined;
      } else {
        if (value.startsWith('product-')) {
          this.listQuery.productId = [+value.replace('product-', '')];
          this.listQuery.productVariationId = undefined;
        } else if (value.startsWith('variation-')) {
          this.listQuery.productId = undefined;
          this.listQuery.productVariationId = [+value.replace('variation-', '')];
        }
      }
    } else {
      this.listQuery.productId = undefined;
      this.listQuery.productVariationId = undefined;
    }
    this.handleFilter();
  }
  async handleSearch() {
    this.hasSearched = true;
    await this.handleFilter();
  }
  async handleFilter() {
    var _AdminModule$branchId;
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    if (this.listQuery.stateId) {
      this.getCityList(this.listQuery.stateId);
    }
    this.listQuery.page = 1;
    if ((!isSuperAdmin() || !isAdmin()) && ((_AdminModule$branchId = AdminModule.branchIds) === null || _AdminModule$branchId === void 0 ? void 0 : _AdminModule$branchId.length) === 1) {
      this.listQuery.branchId = AdminModule.branchIds[0];
    }
    if (this.listQuery.branchId !== undefined && this.listQuery.branchId.length > 0) {
      this.agentList = await BranchAgentService.fetchAgents(this.listQuery.branchId);
      await BranchAgentService.fetchBranches(this.listQuery.branchId);
      this.getList();
    } else {
      this.getList();
    }
  }
  async handleClearCache() {
    try {
      await this.$confirm('Are you sure you want to clear the cache?', 'Confirmation', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      });
      await clearItemWiseSalesLedgerCache();
      this.$message.success('Cache cleared successfully');
      this.getList();
    } catch (error) {
      this.$message.info('Cache clear cancelled');
    }
  }
  getAdminByRole(mappedAdmins, roleName) {
    if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
    const admin = mappedAdmins.find(a => {
      var _a$roles;
      return a === null || a === void 0 || (_a$roles = a.roles) === null || _a$roles === void 0 ? void 0 : _a$roles.some(r => (r === null || r === void 0 ? void 0 : r.name) === roleName);
    });
    return admin ? admin.fullName : '';
  }
  normalizeHeader(value) {
    return String(value === null || value === undefined ? '' : value).toLowerCase().replace(/[^a-z0-9]/g, '');
  }
  // Cells carry the display form of a value - padded, wrapped onto a second
  // line (the Item column renders the variation under the product name), or
  // numeric where the API gives a string - so both sides are folded down to
  // the same shape before they are compared.
  normalizeKeyPart(value) {
    return String(value === null || value === undefined ? '' : value).split('\n')[0].trim().toLowerCase();
  }
  buildRowKey(values) {
    const parts = values.map(value => this.normalizeKeyPart(value));
    return parts.some(part => part === '') ? '' : parts.join('\u0000');
  }
  // Locates the header row and the join scheme it supports. Returns null when
  // no scheme's columns are all present, so the caller can leave the sheet
  // alone rather than guess at the alignment.
  findManagerJoinTarget(data) {
    const limit = Math.min(data.length, 20);
    for (let rowIndex = 0; rowIndex < limit; rowIndex++) {
      const row = data[rowIndex];
      if (!Array.isArray(row)) continue;
      const normalized = row.map(cell => this.normalizeHeader(cell));
      for (const scheme of MANAGER_JOIN_SCHEMES) {
        const columns = scheme.headers.map(header => normalized.indexOf(header));
        if (columns.every(column => column !== -1)) {
          return {
            headerRowIndex: rowIndex,
            columns,
            fields: scheme.fields
          };
        }
      }
    }
    return null;
  }
  buildManagerIndex(allData, fields) {
    const index = new Map();
    for (const row of allData) {
      const key = this.buildRowKey(fields.map(field => row === null || row === void 0 ? void 0 : row[field]));
      if (key === '' || index.has(key)) continue;
      index.set(key, row === null || row === void 0 ? void 0 : row.mappedAdmins);
    }
    return index;
  }
  async appendManagerColumns(blob, allData) {
    const getRole = (mappedAdmins, roleName) => {
      if (!mappedAdmins || !Array.isArray(mappedAdmins)) return '';
      const admin = mappedAdmins.find(a => {
        var _a$roles2;
        return a === null || a === void 0 || (_a$roles2 = a.roles) === null || _a$roles2 === void 0 ? void 0 : _a$roles2.some(r => (r === null || r === void 0 ? void 0 : r.name) === roleName);
      });
      return admin ? admin.fullName : '';
    };
    const arrayBuffer = await blob.arrayBuffer();
    const wb = XLSX.read(arrayBuffer, {
      type: 'array'
    });
    let joinedSheets = 0;
    let dataRows = 0;
    let matchedRows = 0;
    for (const sheetName of wb.SheetNames) {
      const ws = wb.Sheets[sheetName];
      const data = XLSX.utils.sheet_to_json(ws, {
        header: 1
      });
      if (!data.length) continue;
      const target = this.findManagerJoinTarget(data);
      if (!target) continue;
      const index = this.buildManagerIndex(allData, target.fields);
      const headers = data[target.headerRowIndex];
      // sheet_to_json truncates each row at its last non-empty cell, so a data
      // row can be wider than the header row; the new columns go after the
      // widest row to make sure they never land on top of existing values.
      const branchColumn = data.reduce((width, row) => Math.max(width, Array.isArray(row) ? row.length : 0), 0);
      headers.length = branchColumn;
      headers.push('Branch Manager', 'Zonal Manager');
      for (let i = target.headerRowIndex + 1; i < data.length; i++) {
        const row = data[i];
        if (!Array.isArray(row) || !row.length) continue;
        const key = this.buildRowKey(target.columns.map(column => row[column]));
        if (key === '') continue;
        dataRows++;
        const admins = index.get(key);
        if (admins === undefined) continue;
        matchedRows++;
        // Short rows are padded so the two names land under their headers
        // instead of in whichever columns the row happened to stop at.
        while (row.length < branchColumn) row.push('');
        row[branchColumn] = getRole(admins, 'Branch Manager');
        row[branchColumn + 1] = getRole(admins, 'Zonal Manager');
      }
      wb.Sheets[sheetName] = XLSX.utils.aoa_to_sheet(data);
      joinedSheets++;
    }
    if (!joinedSheets) {
      this.$message.warning('Could not match manager names to the exported rows, so the Branch Manager and Zonal Manager columns were left out.');
      return blob;
    }
    if (matchedRows < dataRows) {
      this.$message.warning(`Manager names are missing for ${dataRows - matchedRows} of ${dataRows} exported rows.`);
    }
    const wbout = XLSX.write(wb, {
      bookType: 'xlsx',
      type: 'array'
    });
    return new Blob([wbout], {
      type: 'application/octet-stream'
    });
  }
  async handleExcelDownload() {
    this.downloadLoading = true;
    this.listQuery = cleanListQuery(this.listQuery);
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    }
    try {
      const queryWithoutPagination = {
        ...this.listQuery
      };
      delete queryWithoutPagination.page;
      delete queryWithoutPagination.limit;
      if (this.categoryId) {
        queryWithoutPagination.categoryId = this.categoryId;
      }
      if (this.subCategoryId) {
        queryWithoutPagination.subCategoryId = this.subCategoryId;
      }
      const blob = await downloadExcelItemWiseSalesLedger({
        query: queryWithoutPagination
      });
      let allData = [];
      try {
        const allDataResponse = await getItemWiseSalesLedgerReport(getQuery({
          ...queryWithoutPagination,
          limit: 100000
        }));
        allData = (allDataResponse === null || allDataResponse === void 0 ? void 0 : allDataResponse.data) || [];
      } catch (e) {
        this.$message.warning('Could not load manager names; they will be missing from the export.');
      }
      const modifiedBlob = await this.appendManagerColumns(blob, allData);
      const url = window.URL.createObjectURL(modifiedBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'item-wise-sales-ledger-report.xlsx';
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.$message.error(await this.extractBlobErrorMessage(error));
    } finally {
      this.downloadLoading = false;
    }
  }
  // The Excel endpoint now streams the workbook via ExcelJS, and reports
  // errors (e.g. no data found) as a JSON body on a non-2xx status. Since
  // the request uses responseType 'blob', axios delivers that JSON as an
  // unreadable Blob on error.response.data instead of parsed text - this
  // reads it back out so the real server message reaches the user.
  async extractBlobErrorMessage(error) {
    var _error$response;
    // request.ts rejects with error.response.data directly, so error may be the Blob itself
    const data = error instanceof Blob ? error : error === null || error === void 0 || (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.data;
    if (data instanceof Blob) {
      try {
        const text = await data.text();
        const parsed = JSON.parse(text);
        if (parsed !== null && parsed !== void 0 && parsed.message) {
          return parsed.message;
        }
      } catch (e) {} // eslint-disable-line no-empty
    }
    return 'Error downloading Excel';
  }
};
default_1 = __decorate([Component({
  name: 'ItemWiseSalesLedgerReport',
  components: {
    Pagination,
    Inr
  }
})], default_1);
export default default_1;